import { render, staticRenderFns } from "./ModalDeliveryDriverAssociation.vue?vue&type=template&id=7c53611c"
import script from "./ModalDeliveryDriverAssociation.vue?vue&type=script&lang=ts"
export * from "./ModalDeliveryDriverAssociation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports